import React from "react";
import { Col, Row } from "react-bootstrap";
import ReactElasticCarousel from "react-elastic-carousel";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { imageUrl } from "../../config/apiUrl";
import { CardDemoImg } from "../../constant/imagePath";
import { addItemToCart, removeItemFromCart } from "../../redux/cart/cart";
import Button from "../Button/Button";
import CarouselPagination from "../CarouselPagination";
import MainCard from "../MainCard";
import ModalSkeleton from "../ModalSkeleton/ModalSkeleton";
import ShowMoreShowLessText from "../ShowMoreShowLess/ShowMoreShowLessText";
import classes from "./FeaturedCardModal.module.css";
import { AiOutlineShareAlt, AiOutlineCloseCircle } from "react-icons/ai";
import { IconButton } from "@mui/material";
import { CopyToClipboard } from "react-copy-to-clipboard";

const FeaturedCardModal = ({ data, show, setShow, isCarousel = false }) => {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state?.cartReducer?.cart);
  const token = useSelector((state) => state?.authReducer?.access_token);

  const handleItemPress = () => {
    if (!token) return toast.warn("Please login first.");
    if (cart?.some((e) => e?._id === data?._id)) {
      dispatch(removeItemFromCart(data));
    } else {
      dispatch(addItemToCart(data));
    }
  };

  return (
    <>
      <style>
        {`
       .rec-carousel-wrapper .cus_b{
        margin-top:5px !important;
      }
      `}
      </style>
      <ModalSkeleton
        modalWidth={"32%"}
        modalPadding={"60px"}
        show={show}
        setShow={setShow}
        className={classes.modalMain}
      >
        <div className={classes.main_div}>
          {isCarousel ? (
            <ReactElasticCarousel
              breakPoints={carouselSetting}
              renderPagination={CarouselPagination}
            >
              {data?.cards?.map((e, i) => (
                <div className={classes.cardImg_div} key={i}>
                  <img src={imageUrl(e?.photo)} />
                </div>
              ))}
            </ReactElasticCarousel>
          ) : (
            <div className={classes.cardImg_div}>
              <img src={imageUrl(data?.photo)} />
            </div>
          )}
          <h3 className="t-t-c">{data?.name}</h3>
          <p className={classes.cat_main}>
            <span className="t-t-c">CATEGORY: </span>
            {data?.category?.name}
          </p>
          <h4 style={{ wordBreak: "break-all" }}>
            <ShowMoreShowLessText text={data?.description} />
          </h4>
          <Row style={{ justifyContent: "center" }}>
            {data?.tags?.map((e, i) => {
              return (
                <Col
                  md={4}
                  key={i}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <div className={classes.tag_div}>
                    <div className={classes.tag_b}>
                      <p className="maxLine1 t-t-c"># {e?.name}</p>
                    </div>
                  </div>
                </Col>
              );
            })}
            <div className={classes.mar_t}>
              <Button
                className={classes.addtoCartBtn}
                primary={!cart?.some((e) => e?._id === data?._id)}
                customStyle={{ padding: "10px 70px" }}
                onClick={handleItemPress}
              >
                {cart?.some((e) => e?._id === data?._id)
                  ? "Remove from Cart"
                  : "Add to Cart"}
              </Button>
            </div>
          </Row>
          <div className={classes?.icon}>
            <IconButton className="me-1">
              <CopyToClipboard
                text={`${window.location.origin}/cardDetail/${data?._id}`}
                onCopy={() => toast.success("Link copied to clipboard.")}
              >
                <AiOutlineShareAlt />
              </CopyToClipboard>
            </IconButton>
            <IconButton onClick={() => setShow(false)}>
              <AiOutlineCloseCircle />
            </IconButton>
          </div>
        </div>
      </ModalSkeleton>
    </>
  );
};

export default FeaturedCardModal;

const carouselSetting = [
  { width: 1, itemsToShow: 1, showArrows: false },
  {
    width: 500,
    itemsToShow: 2,
    itemsToScroll: 2,
    pagination: false,
    showArrows: false,
    itemPadding: [0, 10],
  },
  { width: 850, itemsToShow: 3, showArrows: false, itemPadding: [0, 10] },
];
